export const hasNonGenericRepName = (vipRepFirstName: string): boolean =>
    !!vipRepFirstName && !vipRepFirstName.includes('PCS');
